<template>
    <div class="logincent">
        <div class="conten" >
            <h2>{{$t('xgmm')}}</h2>
            <van-form  class="fromctent">
                <!-- <van-field
                v-model="name"
                :placeholder="$t('yhm')"
                :border="true"
                
                clearable
                size='large'
                /> -->
				<div class="phone">
					<select @click="selectHand">
					    <option :value ="this.address">{{this.address}}</option>
					</select>
					<van-field
					    v-model="mobile"
					    :placeholder="$t('sjhm')"
					    :border="true"
					    clearable
					    size='large'
					    />
				</div>
					
                <van-field
                v-model="old_password"
                :placeholder="$t('jmm')"
                :border="true"
                clearable
                size='large'
                />
                <van-field
                v-model="password"
                type="password"
                :placeholder="$t('xmm')"
                :border="true"
                clearable
                size='large'
                />

                <div style="margin-top: 26px;">
                    <van-button  block color="#48C9B0" class="loginbut" native-type="submit" @click="onSubmit">
                        <span style="font-size: 22px;">{{$t('qd')}}</span>
                    </van-button
                >
                </div>
            </van-form>
            
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
export default {
    data(){
        return{
            mobile:'',
            name:'',
            old_password:'',
            password:'',
            // address:localStorage.getItem("address")?localStorage.getItem:'+86'
			address:localStorage.getItem('address')?localStorage.getItem('address'):'+86',
        }
    },
    // mounted(){
    //     // this.address = window.localStorage.getItem("address")?window.localStorage.getItem:'+86'
    //     // console.log( window.localStorage.getItem("address"))
    // },
    methods:{
		selectHand(){
		    this.$router.push({path:'/indexbar'})
		    
		},
        onSubmit(){
			let mobiles
			if(this.address=="+86"){
			    mobiles =this.mobile
			}else{
			    mobiles =this.address+'-'+ this.mobile
			}
            let data={
                method:"co.wx.pwd.modify",
                // name:this.name,
                mobile:mobiles,
                old_password:this.$md5(this.old_password),
                password:this.$md5(this.password)
            }
            this.$serve(data).then(res=>{
                if(res.data.code==0){
                    Toast.success(this.$t('szcg'));
                    window.localStorage.removeItem('getTokendata')
                    this.$router.push({ path: '/login' })
                }else{
                    Toast.fail(this.$t('szsb'));
                }
            })
        }
    }
}
</script>


<style scoped>
.logincent {
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.conten {
  width: 90%;
  height: auto;
  padding-top: 20px;
  margin-top:20%;
  border-radius: 10px;
  /* box-shadow: #d5d5d5 0px 0px 10px; */
}
.fromctent{
    width: 88%;
    margin: 0 auto;
    margin-top:30px;
}
.fromctent >>>.van-field__left-icon .van-icon-friends{
    font-size: 26px;
    margin-left: -5px;
    color: #CCCCCC;
}
.fromctent >>>.van-cell--large{
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    padding: 8px;
    margin-bottom: 10px;
}
.fromctent >>>.van-cell--center{
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    padding: 4px;
}
.fromctent >>>.van-field__left-icon .van-icon-bag{
    font-size: 28px;
    /* margin-left: 2px; */
    color: #CCCCCC;
}
.logintop{
    padding: 0 20px;
    margin-top:30px;color:#48C9B0;
    display: flex;
    justify-content: space-between;
}
.phone{
	display: flex;
}
.phone select{
	
    height: 40px;
    border: none;
    line-height: 32px;
    padding:2px;
    border: 1px solid #7F7F7F;
	border-right: none;
    background-color: #fff;
    color: #323233;
}
</style>